import React from "react";
import { Route, Switch } from "react-router-dom";

import {
  AdminSettings,
  DataImportRuns,
  DataImports,
  DomainUsers,
  DomainDataSources,
} from "../ExtAdmin/components";
import { Alerts } from "../ExtAdmin/components/Alerts";
import { WebDashboards } from "../ExtAdmin/components/WebDashboards";
import { WritebackRuns } from "../ExtAdmin/components/WritebackRuns";
import { Writebacks } from "../ExtAdmin/components/Writebacks";

type Props = {
  baseUrl: string;
  domain: string;
};

export const WorkspaceAdminRoutes: React.FC<Props> = ({ baseUrl, domain }) => {
  return (
    <Switch>
      <Route path={`${baseUrl}/users`} component={DomainUsers} />

      <Route path={`${baseUrl}/data_sources`} component={DomainDataSources} />

      <Route path={`${baseUrl}/imports`} component={DataImports} />

      <Route path={`${baseUrl}/runs`} component={DataImportRuns} />

      <Route path={`${baseUrl}/writebacks`} component={Writebacks} />

      <Route path={`${baseUrl}/writeback_runs`} component={WritebackRuns} />

      <Route path={`${baseUrl}/alerts`} component={Alerts} />

      {/* TODO(follow-up): gate on paid-domain (per spec) — see the Part 3 limit-enforcement work. */}
      <Route path={`${baseUrl}/web_dashboards`} component={WebDashboards} />

      <Route path={`${baseUrl}/settings`} render={() => <AdminSettings domain={domain} />} />

      <Route path={baseUrl} component={DomainUsers} />
    </Switch>
  );
};
